<div class="media-preview-dialog">
  <!-- Header -->
  <div class="media-preview-dialog__header">
    <div class="media-preview-dialog__header-left">
      <span class="media-preview-dialog__title">{{ data.fileName | filenameExtractor }}</span>
    </div>
    <button
      type="button"
      class="media-preview-dialog__close"
      (click)="onClose()"
      aria-label="Close"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="12" fill="#96080B"/>
        <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <!-- Main Content -->
  <div class="media-preview-dialog__content">
    <div class="media-preview-dialog__main" #imageMain>
      @if (isImage()) {
        <div class="media-preview-dialog__image-frame"
             [style.width]="imageFrameWidth"
             [style.height]="imageFrameHeight">
          <img
            [src]="url"
            [alt]="data.fileName"
            class="media-preview-dialog__image"
            (load)="onImageLoad($event)"
          />
        </div>
      } @else if (isVideo()) {
        <video [src]="url" controls class="media-preview-dialog__video">
          Your browser does not support the video tag.
        </video>
      }
    </div>
  </div>
</div>
